import { AnimatedPageWrapper } from "../Layout";

function Page({ children }) {
  return (
    <AnimatedPageWrapper>
      {children}
    </AnimatedPageWrapper>
  );
}

export default Page;
